import { render, staticRenderFns } from "./UnfurlAndFoldBG.vue?vue&type=template&id=f3732f28&scoped=true&"
import script from "./UnfurlAndFoldBG.vue?vue&type=script&lang=js&"
export * from "./UnfurlAndFoldBG.vue?vue&type=script&lang=js&"
import style0 from "./UnfurlAndFoldBG.vue?vue&type=style&index=0&id=f3732f28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3732f28",
  null
  
)

export default component.exports